import CreateDashboard from "./CreateDashboard";

interface EmptyDashboardsProps {
  onCreateDashboard: (dashboardId: string) => void;
}

const EmptyDashboards = ({
  onCreateDashboard,
}: EmptyDashboardsProps) => {
  return (
    <div className="flex-1 flex flex-row sm-h:flex-col items-center justify-center gap-5 overflow-hidden">
      <img src="empty-dashboards.svg" className="h-full max-h-52 sm-h:max-h-48 md-h:max-h-64 lg-h:max-h-80 xl-h:max-h-96 object-contain" />

      <div className="flex flex-col items-center justify-center gap-5">
        <div className="flex flex-col items-center gap-1">
          <p className="text-lg font-bold">
            Você ainda não possui dashboard
          </p>

          <p className="text-sm text-white-400">
            Crie seu primeiro dashboard e comece a visualziar seus dados
          </p>
        </div>

        <CreateDashboard
          onCreateDashboard={onCreateDashboard}
        />
      </div>
    </div>
  );
}

export default EmptyDashboards;
